import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { toast } from 'react-toastify';
import {
  getJewelleryRequest,
  getJewellerySuccess,
  getJewelleryFailure,
  saveJewelleryRequest,
  saveJewellerySuccess,
  saveJewelleryFailure,
  editJewelleryRequest,
  editJewellerySuccess,
  editJewelleryFailure,
  changeJewelleryStatusRequest,
  changeJewelleryStatusSuccess,
  changeJewelleryStatusFailure,
  deleteJewelleryRequest,
  deleteJewellerySuccess,
  deleteJewelleryFailure,
  addJewelleryInventoryRequest, 
  addJewelleryInventorySuccess, 
  addJewelleryInventoryFailure, 
  getJewelleryOrdersRequest,
  getJewelleryOrdersSuccess,
  getJewelleryOrdersFailure,
  changeJewelleryOrderStatusRequest,
  changeJewelleryOrderStatusSuccess,
  changeJewelleryOrderStatusFailure,
  toggleJewelleryInventoryRequest,
  toggleJewelleryInventorySuccess,
  toggleJewelleryInventoryFailure,
  editJewelleryInventoryRequest,
  editJewelleryInventorySuccess,
  editJewelleryInventoryFailure,
} from './JewellerySlice';


// Fetch list of jewellery
function* fetchJewellerySaga(action) {
  try {
    const { page = 1, limit = 10, search = '' } = action.payload || {};
    const params = { page, limit };
    if (search) params.search = search;

    const response = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/artificial-jewellery/getArtificialJewellery`, { params }),
    );

    if (!response.data?.success) {
      yield put(
        getJewelleryFailure(response.data?.message || 'Something went wrong'),
      );
      return;
    }

    yield put(getJewellerySuccess(response.data));
  } catch (error) {
    console.error('Fetch jewellery error:', error);
    yield put(
      getJewelleryFailure(
        error.response?.data?.message || 'Something went wrong',
      ),
    );
  }
}

// Create jewellery 
function* createJewellerySaga(action) {
  try {
    const response = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/artificial-jewellery/createArtificialJewellery`, action.payload),
    );

    if (!response.data?.success) {
      const message = response.data?.message || 'Failed to add jewellery';
      yield put(saveJewelleryFailure(message));
      yield call(toast.error, message);
      return;
    }

    yield put(saveJewellerySuccess(response.data));
    yield call(toast.success, response.data?.message || 'Jewellery added successfully');
    yield put(getJewelleryRequest({ page: 1, limit: 10 }));
  } catch (error) {
    console.error('Create jewellery error:', error);
    const message = error.response?.data?.message || 'Something went wrong while adding jewellery';
    yield put(saveJewelleryFailure(message));
    yield call(toast.error, message);
  }
}

// Edit jewellery )
function* updateJewellerySaga(action) {
  try {
    const { id, formData } = action.payload;

    const response = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/artificial-jewellery/editArtificialJewellery/${id}`, formData),
    );

    if (!response.data?.success) {
      const message = response.data?.message || 'Failed to update jewellery';
      yield put(editJewelleryFailure(message));
      yield call(toast.error, message);
      return;
    }

    yield put(editJewellerySuccess(response.data));
    yield call(toast.success, response.data?.message || 'Jewellery updated successfully');
    yield put(getJewelleryRequest({ page: 1, limit: 10 }));
  } catch (error) {
    console.error('Edit jewellery error:', error);
    const message = error.response?.data?.message || 'Something went wrong while updating jewellery';
    yield put(editJewelleryFailure(message));
    yield call(toast.error, message);
  }
}

// Change enabled / disabled status 
function* changeJewelleryStatusSaga(action) {
  try {
    const response = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/artificial-jewellery/changeArtificialJewelleryStatus`, action.payload, {
        headers: { 'Content-Type': 'application/json' },
      }),
    );

    if (!response.data?.success) {
      const message = response.data?.message || 'Failed to update status';
      yield put(changeJewelleryStatusFailure(message));
      yield call(toast.error, message);
      return;
    }

    yield put(changeJewelleryStatusSuccess(response.data));
    yield call(toast.success, response.data?.message || 'Status updated successfully');
    yield put(getJewelleryRequest({ page: 1, limit: 10 }));
  } catch (error) {
    console.error('Change jewellery status error:', error);
    const message = error.response?.data?.message || 'Something went wrong while updating status';
    yield put(changeJewelleryStatusFailure(message));
    yield call(toast.error, message);
  }
}

//delete jewellery 
function* deleteJewellerySaga(action) {
try {
  const jewelleryId =
    typeof action.payload === 'string'
      ? action.payload
      : action.payload?.id;

  if (!jewelleryId) {
    const message = 'Jewellery ID is missing';
    yield put(deleteJewelleryFailure(message));
    yield call(toast.error, message);
    return;
  }

  const response = yield call(() =>
    axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/artificial-jewellery/deleteArtificialJewellery/${jewelleryId}`
    )
  );

  if (!response.data?.success) {
    const message =
      response.data?.message || 'Failed to delete jewellery';

    yield put(deleteJewelleryFailure(message));
    yield call(toast.error, message);
    return;
  }

  yield put(deleteJewellerySuccess(response.data));
  yield call(
    toast.success,
    response.data?.message || 'Jewellery deleted successfully'
  );
} catch (error) {
  console.error('Delete jewellery error:', error);

  const message =
    error.response?.data?.message ||
    'Something went wrong while deleting jewellery';

  yield put(deleteJewelleryFailure(message));
  yield call(toast.error, message);
}
}

function* addJewelleryInventorySaga(action) {
  try {
    const response = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/artificial-jewellery/addArtificialJewelleryInventory`, action.payload, {
        headers: { 'Content-Type': 'application/json' },
      }),
    );

    if (!response.data?.success) {
      const message = response.data?.message || 'Failed to add inventory';
      yield put(addJewelleryInventoryFailure(message));
      yield call(toast.error, message);
      return;
    }

    yield put(addJewelleryInventorySuccess(response.data));
    yield call(toast.success, response.data?.message || 'Inventory added successfully');
  } catch (error) {
    console.error('Add jewellery inventory error:', error);
    const message = error.response?.data?.message || 'Something went wrong while adding inventory';
    yield put(addJewelleryInventoryFailure(message));
    yield call(toast.error, message);
  }
}

function* editJewelleryInventorySaga(action) {
  try {
    const { id, formData } = action.payload || {};
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/artificial-jewellery/editArtificialJewelleryInventory/${id}`,
        formData,
        { headers: { 'Content-Type': 'application/json' } },
      ),
    );

    if (!response.data?.success) {
      const message = response.data?.message || 'Failed to update inventory';
      yield put(editJewelleryInventoryFailure(message));
      yield call(toast.error, message);
      return;
    }

    yield put(editJewelleryInventorySuccess(response.data));
    yield call(toast.success, response.data?.message || 'Inventory updated successfully');
  } catch (error) {
    console.error('Edit jewellery inventory error:', error);
    const message = error.response?.data?.message || 'Something went wrong while updating inventory';
    yield put(editJewelleryInventoryFailure(message));
    yield call(toast.error, message);
  }
}

function* toggleJewelleryInventorySaga(action) {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/artificial-jewellery/changeArtificialJewelleryInventoryStatus`,
        action.payload,
        { headers: { 'Content-Type': 'application/json' } },
      ),
    );

    if (!response.data?.success) {
      const message = response.data?.message || 'Failed to update inventory status';
      yield put(toggleJewelleryInventoryFailure(message));
      yield call(toast.error, message);
      return;
    }

    yield put(toggleJewelleryInventorySuccess(response.data));
    yield call(toast.success, response.data?.message || 'Inventory status updated successfully');
  } catch (error) {
    const message = error.response?.data?.message || 'Something went wrong while updating inventory status';
    yield put(toggleJewelleryInventoryFailure(message));
    yield call(toast.error, message);
  }
}

function buildOrderListParams({ page = 0, limit = 10, search = '', startDate, endDate }) {
  const params = {
    page: page + 1,
    limit,
  };
  if (search && String(search).trim()) {
    params.search = String(search).trim();
  }
  if (startDate && endDate) {
    params.startDate = startDate;
    params.endDate = endDate;
  }
  return params;
}

function* fetchJewelleryOrdersSaga(action) {
  try {
    const params = buildOrderListParams(action.payload || {});
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/artificial-jewellery/getArtificialJewelleryOrders`,
        { params },
      ),
    );

    if (!response.data?.success) {
      const message = response.data?.message || 'Get jewellery orders failed.';
      yield put(getJewelleryOrdersFailure(message));
      yield call(toast.error, message);
      return;
    }

    yield put(getJewelleryOrdersSuccess(response.data));
  } catch (error) {
    console.error('Fetch jewellery orders error:', error);
    const message =
      error.response?.data?.message || error.message || 'Failed to fetch jewellery orders';
    yield put(getJewelleryOrdersFailure(message));
    yield call(toast.error, message);
  }
}

function* changeJewelleryOrderStatusSaga(action) {
  try {
    const { order_id, status, ...listQuery } = action.payload || {};

    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/artificial-jewellery/changeArtificialJewelleryOrderStatus`,
        { order_id, status },
        { headers: { 'Content-Type': 'application/json' } },
      ),
    );

    if (!response.data?.success) {
      const message = response.data?.message || 'Failed to update order status';
      yield put(changeJewelleryOrderStatusFailure(message));
      yield call(toast.error, message);
      return;
    }

    yield put(changeJewelleryOrderStatusSuccess(response.data));
    yield call(toast.success, response.data?.message || 'Status updated successfully');
    yield put(getJewelleryOrdersRequest(listQuery));
  } catch (error) {
    console.error('Change jewellery order status error:', error);
    const message =
      error.response?.data?.message || error.message || 'Failed to update order status';
    yield put(changeJewelleryOrderStatusFailure(message));
    yield call(toast.error, message);
  }
}

export default function* jewellerySaga() {
  yield takeLatest(getJewelleryRequest.type, fetchJewellerySaga);
  yield takeEvery(saveJewelleryRequest.type, createJewellerySaga);
  yield takeEvery(editJewelleryRequest.type, updateJewellerySaga);
  yield takeEvery(changeJewelleryStatusRequest.type, changeJewelleryStatusSaga);
  yield takeEvery(deleteJewelleryRequest.type, deleteJewellerySaga);
  yield takeEvery(addJewelleryInventoryRequest.type, addJewelleryInventorySaga); 
  yield takeLatest(getJewelleryOrdersRequest.type, fetchJewelleryOrdersSaga);
  yield takeLatest(changeJewelleryOrderStatusRequest.type, changeJewelleryOrderStatusSaga);
  yield takeLatest(toggleJewelleryInventoryRequest.type, toggleJewelleryInventorySaga);
  yield takeEvery(editJewelleryInventoryRequest.type, editJewelleryInventorySaga);
}